import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAttributes from '../lockupAttributes'
import LockupFilesIncluded from '../lockupFilesIncluded'
import LockupTagsOnMobile from '../lockupTagsOnMobile'

import CommonItemCardLayout from '../commonItemCardLayout'

const CodeCanyonItemCard = (props: IItemCard) => {
  const { tags = '', term = '' } = props.locationParams
  return (
    <CommonItemCardLayout {...props}>
      <LockupAttributes {...props} />
      <LockupFilesIncluded {...props} />
      <LockupTagsOnMobile {...props} tags={tags} term={term} />
    </CommonItemCardLayout>
  )
}

export default CodeCanyonItemCard
